import { type AxiosInstance } from 'axios'

type CreateAssetData = {
  asset_name: string
  description: string | null
  ownership: string | null
  geolocation: string | null
  ownership_date: string | null
  emission_categories: Array<number>
  data_collection_frequency: string | null
  parent_node: number | null
}

type UpdatedAsset = {
  asset_name: string
  description?: string | null
  ownership?: string | null
  geolocation?: string | null
  ownership_date?: string | null
  emission_categories?: Array<number>
  data_collection_frequency?: string | null
  parent_node?: number | null
}
interface ApproachData {
  setting: 'operational_control' | 'financial_control' | 'equity_share'
}

export default (axios: AxiosInstance) => ({
  listAll(params?: AssetsQueryParams) {
    return axios.get<Asset[]>('/v1/assets/', { params })
  },
  listClasses() {
    return axios.get('/v1/assets/distinct-asset-classes-list/')
  },
  create(createData: CreateAssetData) {
    return axios.post('/v1/assets/', createData)
  },
  update(assetId: number, updateData: UpdatedAsset) {
    return axios.put(`/v1/assets/${assetId}/`, updateData)
  },
  listGeolocations() {
    return axios.get('/v1/assets/assets-geolocation/')
  },
  assetClasses(pcafStatus: boolean) {
    return axios.get(`/v1/assets/asset-classes/?pcaf=${pcafStatus}`)
  },
  assetApproachData() {
    return axios.get('/v1/assets/approach/')
  },
  dataOwnerAssets(categoryId: number) {
    return axios.get<AssetItem[]>(`/v1/assets/category/${categoryId}/data-owner-assets/`)
  },

  getApproach() {
    return axios.get(`/v1/assets/approach/`)
  },
  editAsset(assetId: number) {
    return axios.get(`/v1/assets/${assetId}/`)
  },
  archiveAssets(id: number) {
    return axios.put(`/v1/assets/archive/${id}/`)
  },
  deleteAssets(id: number) {
    return axios.put(`/v1/assets/delete/${id}/`)
  },
  createApproach(data: ApproachData) {
    return axios.post(`/v1/assets/approach/`, data)
  },
  assetRegionsData() {
    return axios.get('/v1/assets/assets-regions/')
  },
  list(params?: ListAssetsQueryParams) {
    return axios.get<PaginatedResponse<OptionItem>>('/v2/esg/assets/', { params })
  },
})
